// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OptionsShort
 */
export interface OptionsShort {
  /**
   *
   */
  active: boolean;
}

/**
 * Check if a given object implements the OptionsShort interface.
 */
export function instanceOfOptionsShort(value: object): value is OptionsShort {
  if (!("active" in value) || value["active"] === undefined) return false;
  return true;
}

export function OptionsShortFromJSON(json: any): OptionsShort {
  return OptionsShortFromJSONTyped(json, false);
}

export function OptionsShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionsShort {
  if (json == null) {
    return json;
  }
  return {
    active: json["active"],
  };
}

export function OptionsShortToJSON(json: any): OptionsShort {
  return OptionsShortToJSONTyped(json, false);
}

export function OptionsShortToJSONTyped(
  value?: OptionsShort | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    active: value["active"],
  };
}
